const errors = {
  AUTH_INCORRECT_CREDENTIALS: "Неправильний email або пароль",
  USER_ALREADY_EXISTS: "Такий користувач уже існує",
  USER_NOT_FOUND: "Користувач не знайдений",
  AUTH_INCORRECT_CONFIRMATION_EMAIL_CODE: "Неправильний код, спробуйте ще раз!",
  NEW_PASSWORD_AND_OLD_PASSWORD_CANNOT_BE_SAME:
    "Новий пароль і старий пароль не можуть бути однаковими",
  AUTH_PASSWORDS_DO_NOT_MATCH: "Неправильний пароль",
  AUTH_INVALID_REFRESH_TOKEN: "Термін сесії закінчився",
};

export function getErrorMessage(error) {
  let errorMessage = "Невідома помилка";
  if (error.response) {
    errorMessage = errors[error.response.data.message[0]] || errorMessage;
  }
  return errorMessage;
}

export function getFieldErrorMessages(field, ruleMessages) {
  if (!field.$dirty) return [];
  return Object.entries(ruleMessages).reduce((errors, [rule, message]) => {
    !field[rule] && errors.push(message);
    return errors;
  }, []);
}
